module.exports = __webpack_public_path__ + "img/pic-logo-ync.0131f2ba.png";